import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { DirectionContext, getConfig, getDictionary, getLocale } from "@jti/fe-common";
import { ConfigContext, LocaleContext, TranslationsContext } from "./contexts";
export const ConfigProvider = ({ children, config, locale, translations, direction, }) => {
    const [configValue, setConfigValue] = React.useState(config ?? null);
    const [localeValue, setLocaleValue] = React.useState(locale ?? null);
    const [translationsValue, setTranslationsValue] = React.useState(translations ?? null);
    useEffect(() => {
        // should we set those values only when we are not in next.js app?
        if (!config) {
            setConfigValue(getConfig());
        }
        if (!locale) {
            setLocaleValue(getLocale());
        }
        if (!translations) {
            setTranslationsValue(getDictionary());
        }
    }, []);
    if (!configValue || !localeValue || !translationsValue) {
        return null;
    }
    return (_jsx(ConfigContext.Provider, { value: configValue, children: _jsx(LocaleContext.Provider, { value: localeValue, children: _jsx(TranslationsContext.Provider, { value: translationsValue, children: _jsx(DirectionContext.Provider, { value: direction, children: children }) }) }) }));
};
export function withConfigProvider(Component, config = {}) {
    return (props) => {
        return (_jsx(ConfigProvider, { ...config, children: _jsx(Component, { ...props }) }));
    };
}
//# sourceMappingURL=ConfigProvider.js.map